import { useCallback, useRef, useState } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

export interface ConfirmOptions {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

interface ConfirmState extends ConfirmOptions {
  open: boolean;
}

const DEFAULT_STATE: ConfirmState = {
  open: false,
  message: '',
};

export function useConfirm() {
  const [state, setState] = useState<ConfirmState>(DEFAULT_STATE);
  const resolveRef = useRef<((value: boolean) => void) | null>(null);

  const confirm = useCallback((options: ConfirmOptions) => {
    return new Promise<boolean>((resolve) => {
      resolveRef.current = resolve;
      setState({ ...options, open: true });
    });
  }, []);

  const settle = useCallback((result: boolean) => {
    setState((prev) => ({ ...prev, open: false }));
    resolveRef.current?.(result);
    resolveRef.current = null;
  }, []);

  const ConfirmDialogElement = (
    <Modal
      open={state.open}
      onClose={() => settle(false)}
      title={state.title ?? 'Confirmar ação'}
      footer={
        <div className="flex justify-end gap-2">
          <Button type="button" variant="ghost" size="sm" onClick={() => settle(false)}>
            {state.cancelLabel ?? 'Cancelar'}
          </Button>
          <Button
            type="button"
            variant={state.danger ? 'danger' : 'primary'}
            size="sm"
            onClick={() => settle(true)}
          >
            {state.confirmLabel ?? 'Confirmar'}
          </Button>
        </div>
      }
    >
      <p className="text-sm text-text-medium">{state.message}</p>
    </Modal>
  );

  return { confirm, ConfirmDialogElement };
}
